/** Node types we never show Remix for. */
export const REMIX_DENY_LIST_V1: readonly string[] = [
	'mediaSingle',
	'mediaGroup',
	'media',
	'image',
	'extension',
	'bodiedExtension',
	'multiBodiedExtension',
	'embedCard',
	'blockCard',
	'inlineCard',
	// Source blocks
	'bodiedSyncBlock',
	// Reference blocks
	'syncBlock',
] as const;

const DENY_SET = new Set<string>(REMIX_DENY_LIST_V1);

/** True if this node type is in the remix deny list (restricted). */
export const isRemixRestrictedNodeType = (nodeType: string): boolean => DENY_SET.has(nodeType);
